(function () {
  function init() {
    var burger = document.querySelector('[data-v20-nav-burger]');
    var drawer = document.querySelector('[data-v20-nav-drawer]');
    var scrim = document.querySelector('[data-v20-nav-scrim]');
    var closeBtn = document.querySelector('[data-v20-nav-close]');
    if (!burger || !drawer || !scrim) return;

    function open() {
      drawer.classList.add('is-open');
      scrim.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      scrim.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    burger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    drawer.querySelectorAll('.v20-nav-drawer__links > a').forEach(function (a) {
      a.addEventListener('click', close);
    });

    drawer.querySelectorAll('.v20-nav-drawer__trigger').forEach(function (trigger) {
      var sub = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!sub) return;
      trigger.addEventListener('click', function () {
        var isOpen = sub.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
